<template>
  <div class="matchingDetail">
    <div class="title">
      货源匹配 <span>匹配硬件车辆</span>
    </div>
    <div class="orderview_title">
      货源信息
    </div>
    <div v-bind:class='orderStyle?"order_box":"order_con"'>
      <el-table style="width: 100%"
                :data="orderView"
                class="order_table">
        <!-- <el-table-column
                label=""
                align="center"
                header-align="center"
                type="index"
                width="1"
                fixed
              >
              </el-table-column> -->
        <el-table-column prop="goodsNum"
                         header-align="center"
                         align="left"
                         label="货源编号"
                         width="100">
        </el-table-column>
        <el-table-column header-align="center"
                         label="货主信息"
                         align="left"
                         class-name="order_car">
          <template slot-scope="scope">
            <div class="carInfo">
              <div>
                <span>公司名称：</span>
                {{scope.row.userCompanyName}}
              </div>
              <div>
                <span>联系人姓名：</span>
                {{scope.row.userCompanyLinkman}}
              </div>
              <div>
                <span>联系电话：</span>
                {{scope.row.userCompanyIphone}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="位置信息"
                         align="left"
                         class-name="order_car">
          <template slot-scope="scope">
            <div class="carInfo">
              <div>
                <span>出发地：</span>
                {{scope.row.departLand}}{{scope.row.departLandDetails}}
              </div>
              <div>
                <span>目的地：</span>
                {{scope.row.destina}}{{scope.row.destinaDetails}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="货源信息"
                         align="left"
                         class-name="order_car">
          <template slot-scope="scope">
            <div class="carInfo">
              <div>
                <span>期望运费：</span>
                {{scope.row.expectFreight}}元/吨
              </div>
              <div>
                <span>炼厂名称：</span>
                {{scope.row.refineryName}}
              </div>
              <div>
                <span>原料：</span>
                {{scope.row.material}}
              </div>
              <div>
                <span>重量：</span>
                {{scope.row.totalWeight}}吨
              </div>
              <div class="tankbody">
                <span>罐体：</span>
                <div v-if="scope.row.tankBody === '0'">铝罐</div>
                <div v-else-if="scope.row.tankBody === '1'">铁罐</div>
                <div v-else-if="scope.row.tankBody === '2'">钢罐</div>
                <div v-else-if="scope.row.tankBody === '3'">铝合金</div>
                <div v-else-if="scope.row.tankBody === '4'">其他</div>
              </div>
              <div>
                <span>货源有效期：</span>
                {{scope.row.startTimestr}}至{{scope.row.endTimestr}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="匹配详情"
                         header-align="center"
                         align="left">
          <template slot-scope="scope">
            <div class="carInfo">
              <div>
                <span>已匹配重量：</span>
                {{scope.row.matchWeight}}吨
              </div>
              <div>
                <span>已匹配车辆：</span>
                {{scope.row.matchVehicle}}辆
              </div>
              <div>
                <span>已谈成重量：</span>
                {{scope.row.talkWeight}}吨
              </div>
              <div>
                <span>已谈成车辆：</span>
                {{scope.row.talkVehicle}}辆
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="more">
        <span v-if="orderStyle"
              @click="orderStyle=false">更多</span>
        <span v-else
              class="more_up"
              @click="orderStyle=true">收起</span>
      </div>
    </div>

    <div class="container">
      <div id="container"></div>
      <div class="info">
        点击地图上的点标记，打开所添加的自定义信息窗体
      </div>
      <div class="distance">
        <el-select v-model="distance"
                   placeholder="请选择出发地"
                   size="small"
                   @change="handleDistanceChange">
          <el-option label="50km"
                     value="50"></el-option>
          <el-option label="100km"
                     value="100"></el-option>
          <el-option label="200km"
                     value="200"></el-option>
          <el-option label="300km"
                     value="300"></el-option>
          <el-option label="400km"
                     value="400"></el-option>
          <el-option label="500km"
                     value="500"></el-option>
        </el-select>
      </div>
    </div>
    <div class="carview_title">
      车辆信息
    </div>
    <el-form :inline="true"
             :model="formInline"
             class="carview_form">
      <el-autocomplete class="inline-input permission_search"
                       size='small'
                       v-model="inputName"
                       :fetch-suggestions="querySearch"
                       placeholder="请输入公司名称"
                       :trigger-on-focus="false">
      </el-autocomplete>
      <el-button type="primary"
                 @click="handleSearchClick"
                 class="searchBtn">查询</el-button>
      <!-- <el-button type="primary" @click="handleMathcsClick" plain size="small" class="matchBtn">批量匹配</el-button> -->
    </el-form>
    <el-table style="width: 100%"
              :data="driversList"
              class="carview_table"
              @selection-change="handleSelectionChange">
      <!-- <el-table-column
                type="selection"
                width="56">
            </el-table-column> -->
      <el-table-column class-name="number"
                       label="序号"
                       align="center"
                       type="index"
                       min-width="40"
                       fixed>
      </el-table-column>
      <el-table-column prop="dirverNum"
                       header-align="center"
                       align="center"
                       label="车辆编号">
      </el-table-column>
      <el-table-column header-align="center"
                       label="物流公司"
                       align="left">
        <template slot-scope="scope">
          <div class="carInfo">
            <div>
              <span>公司名称：</span>
              {{scope.row.companyName}}
            </div>
            <div v-if="scope.row.roleType==='0'">
              <span>角色分类：</span>
              物流公司
            </div>
            <div v-else-if="scope.row.roleType==='1'">
              <span>角色分类：</span>
              个人车主
            </div>
            <div v-else-if="scope.row.roleType==='2'">
              <span>角色分类：</span>
              物流中介
            </div>
            <div>
              <span>联系人姓名：</span>
              {{scope.row.linkman}}
            </div>
            <div>
              <span>联系电话：</span>
              {{scope.row.phone}}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center"
                       label="车辆信息"
                       align="left"
                       width="140">
        <template slot-scope="scope">
          <div class="carInfo">
            <div>
              <span>车头号：</span>
              {{scope.row.headNumber}}
            </div>
            <div>
              <span>车挂号：</span>
              {{scope.row.tailNumber}}挂
            </div>
            <div>
              <span>核载量：</span>
              {{scope.row.nuclearLoadTonnage}}吨
            </div>
            <div>
              <span>介质类别：</span>
              {{scope.row.mediumClass}}
            </div>
            <div v-if="scope.row.materialTank==='01'"><span>罐体：</span>铝罐</div>
            <div v-else-if="scope.row.materialTank==='02'"><span>罐体：</span>铁罐</div>
            <div v-else-if="scope.row.materialTank==='03'"><span>罐体：</span>白钢罐</div>
            <div v-else-if="scope.row.materialTank==='04'"><span>罐体：</span>铝合金罐</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center"
                       label="司机信息"
                       align="left">
        <template slot-scope="scope">
          <div class="carInfo">
            <div>
              <span>姓名：</span>
              {{scope.row.dirverName}}
            </div>
            <div>
              <span>手机号：</span>
              {{scope.row.dirverPhone}}
            </div>
            <div>
              <div>身份证号：</div>
              {{scope.row.dirverIdCardNo}}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center"
                       label="车辆状态"
                       align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.vehicleState === '01'"
               class="empty">空车</div>
          <div v-else-if="scope.row.vehicleState === '02'"
               class="wait">待运输</div>
          <div v-else-if="scope.row.vehicleState === '03'"
               class="loaded">重车</div>
        </template>
      </el-table-column>
      <el-table-column header-align="center"
                       label="操作"
                       align="center">
        <template slot-scope="scope">
          <el-button size="small"
                     @click="handleMatchClick(scope.row)"
                     type="primary"
                     class="oprationBtn">匹配</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="提示"
               :visible.sync="matchingCar"
               class="matchingCarTable">
      <div class="matchingCarDetail">
        <p>匹配车辆前请先确定信息是否选择正确</p>
        <div><span>车辆服务费(￥)：</span>
          <el-input size="small"
                    v-model="amount"></el-input> 辆/次
        </div>
        <p class="remarks">服务费设置金额为0—300元</p>
      </div>
      <div class="matchingBtn">
        <div @click="handleCancelClick">取消</div>
        <div @click="handleConfirmClick">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script src="https://webapi.amap.com/maps?v=1.4.13&key=6656a8e9810da0328783e4c374223568"></script>
<script>
// import { matchingOrderView, matchingImages, matchingDriver, matchingCancel, matchingTrack } from 'apis/index'
import {
  heightCarOrder,
  allCompanyList,
  heightMatch,
  searchMatch,
  heightDriverOrder
} from 'apis/index'
export default {
  name: 'matchingDetail',
  data () {
    return {
      orderView: [],
      driversList: [],
      trackpoint: [],
      id: '',
      formInline: {
        companyName: ''
      },
      distance: '50',
      // center: [116.3802337646, 39.8631078118],
      range: '50',
      inputName: '',
      matchingCar: false,
      amount: '',
      driverid: '',
      roleType: '',
      carInfoList: {},
      zoom: 10,
      orderStyle: true
    }
  },
  methods: {
    getAllCompany () { // 初始化获取所有公司列表
      allCompanyList({
        type: 2
      }).then(res => {
        if (res.data.code === 0) {
          this.companyList = res.data.data.result
        }
      })
    },
    handleDistanceChange (command) { // 范围选择
      switch (command) {
        case '50':
          this.zoom = 10
          break
        case '100':
          this.zoom = 9
          break
        case '200':
          this.zoom = 8
          break
        case '300':
          this.zoom = 7
          break
        case '400':
          this.zoom = 6
          break
        case '500':
          this.zoom = 5
          break
      }
      this.range = command
      this.getCompanyOrderList(this.id, command)
    },
    getCompanyOrderList (id, range, company) { // 获取公司运单
      company = !company ? '' : company
      heightCarOrder({
        seniorGoodsId: id,
        range: range,
        companyId: company
      }).then(res => {
        if (res.data.code === 0) {
          this.orderView = []
          this.orderView.push(res.data.data.vhbGoodsSenior)
          this.driversList = res.data.data.vhbDriverList
          // console.log(this.driversList)
          // 货源坐标点，缩放的中心
          let latitude = this.orderView[0].departLatLng.split(',').reverse()
          this.center = latitude
          var map = new AMap.Map("container", { resizeEnable: true, zoom: this.zoom });
          var infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(120, 90) });
          this.driversList.forEach(element => {
            let endtrack = []

            endtrack.push(element.secondlng, element.secondlat)
            // endtrack.push('116.573543', '38.82321')
            let starttrack = []
            starttrack.push(element.lng, element.lat)
            let linePath = []
            linePath.push(starttrack, endtrack)
            var marker = new AMap.Marker({
              map: map,
              position: this.center,
              icon: "http://image.jsh178.com/FmQdHrf-kE2vPHc4AxAH1xHFl0qI",
              offset: new AMap.Pixel(-5, -5),
              autoRotation: true,
            });
            marker.content = "<div><span class='label'>公司名称：</span>" + element.companyName + "</div>"
              + "<div><span class='label'>车头号：</span>" + element.headNumber + "</div>"
              + "<div><span class='label'>车挂号：</span>" + element.tailNumber + " </div>"
              + "<div><span class='label'>核载量：</span>" + element.nuclearLoadTonnage + "吨</div>"
            marker.on('click', markerClick);
            // 绘制轨迹
            var polyline = new AMap.Polyline({
              map: map,
              path: linePath,
              showDir: true,
              strokeColor: "#28F",  //线颜色
              strokeOpacity: 0,     //线透明度
              strokeWeight: 6,      //线宽
              // strokeStyle: "solid"  //线样式
            });
            var passedPolyline = new AMap.Polyline({
              map: map,
              // path: lineArr,
              strokeColor: "#AF5",  //线颜色
              strokeOpacity: 0,     //线透明度
              strokeWeight: 0,      //线宽
              // strokeStyle: "solid"  //线样式
            });
            // marker.on('moving', function (e) {
            //     passedPolyline.setPath(e.passedPath);
            // });
            marker.moveAlong(linePath, 99999999);
            function markerClick (e) {
              infoWindow.setContent(e.target.content);
              infoWindow.open(map, e.target.getPosition());
            }
          });
        }
      })
    },
    handleSearchClick () { // 运输车辆列表查询
      let itemId = ''
      this.companyList.forEach(res => {
        if (res.companyName === this.inputName) {
          itemId = res.companyId
        }
      })
      this.getCompanyOrderList(this.id, this.range, itemId)
    },

    handleCancelClick (id) { // 取消运单
      this.$confirm('确认取消运单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // matchingCancel({
        //   driverOrderId: id
        // }).then(res => {
        //   if (res.data.code === 0) {
        //     this.getDriverList(this.id)
        //     this.$message({
        //       type: 'success',
        //       message: '删除成功!'
        //     })
        //   }
        // })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    matchngMethod (driverId) { // 匹配/批量匹配车辆方法
      // heightMatch({
      //   seniorGoodsId: this.id,
      //   dirverIds: driverId
      // }).then(res => {
      //   if (res.data.code === 0) {
      //     this.getCompanyOrderList(this.id, this.range)
      //   }
      // })
    },
    handleMathcsClick () { // 批量匹配
      // this.$confirm('确认匹配信息无误?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   let iditem = ''
      //   this.multipleSelection.forEach(res => {
      //     iditem += res.dirverId + ','
      //   })
      //   iditem = iditem.substring(0, iditem.length - 1)
      //   this.matchngMethod(iditem)
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消匹配'
      //   })
      // })
    },
    handleMatchClick (item) { // 单独匹配
      // console.log('a', item)
      // console.log(this.driversList)
      if (item.roleType === '0') {
        this.$confirm('确认匹配信息无误?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // console.log(
          //   'item', item,
          //   'id', this.id,
          //   'driverid', item.dirverId,
          //   'roleType', item.roleType
          // )
          heightMatch({
            seniorGoodsId: this.id,
            dirverIds: item.dirverId,
            roleType: item.roleType
          }).then(res => {
            if (res.data.code === 0) {
              for (var i = 0; i < this.driversList.length; i++) {
                if (item.dirverId === this.driversList[i].dirverId) {
                  this.driversList.splice(i, 1)
                }
              }
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消匹配'
          })
        })
        // this.matchingCar = true
        // this.amount = ''
        // this.driverid = item.dirverId
      } else {
        // console.log('type', item.roleType,
        //   'id', this.id,
        //   'amount', this.amount,
        //   'driverid', item.dirverId
        // )
        searchMatch({
          companyId: item.companyId,
          seniorGoodsId: this.id
        }).then(res => {
          if (res.data.code === 0) {
            this.amount = ''
            this.driverid = item.dirverId
            this.roleType = item.roleType
          } else if (res.data.code === 1) {
            this.amount = res.data.data.driverPaySum
            this.driverid = item.dirverId
            this.roleType = item.roleType
          }
          this.matchingCar = true
        })
      }
    },
    handleConfirmClick () { // 确认匹配
      heightMatch({
        seniorGoodsId: this.id,
        dirverIds: this.driverid,
        driverPaySum: this.amount,
        roleType: this.roleType
      }).then(res => {
        // console.log(res)
        if (res.data.code === 0) {
          this.amount = ''
          this.roleType = ''
          // this.driverid = ''
          for (var i = 0; i < this.driversList.length; i++) { // 从当前列别表中删除该数据
            console.log(this.driversList, this.driversList[i].dirverId, this.driverid)
            if (this.driversList[i].dirverId === this.driverid) {
              this.driversList.splice(i, 1)
            }
          }
          this.matchingCar = false
        }
      })
    },
    handleCancelClick () {
      this.matchingCar = false
    },
    handleSelectionChange (val) { // 批量匹配选择框
      this.multipleSelection = val
    },
    querySearch (queryString, cb) { // 模糊查询
      var csvS = this.csvS
      cb(csvS)
    },
    createFilter (queryString) { // 模糊查询
      return (companyList) => {
        return (companyList.companyName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    }
    // remarkPoint (item, icon) {
    //   let o = amapManager.getMap()
    //   // 创建一个 icon
    //   let remark = new AMap.Marker({
    //     position: item,
    //     icon: icon
    //   })
    //   remark.setMap(o)
    // }
  },
  watch: {
    inputName: function () { // 模糊查询
      this.csvS = []
      var len = this.companyList.length
      var arr = []
      for (var i = 0; i < len; i++) {
        if (this.companyList[i].companyName.indexOf(this.inputName) >= 0) {
          arr.push(this.companyList[i])
        }
      }
      // el-autocomplete元素要求数组内是对象，且有value属性
      for (var j = 0; j < arr.length; j++) {
        var obj = { value: '' }
        obj.value = arr[j].companyName
        this.csvS.push(obj)
      }
    }
  },
  mounted () {
    this.id = this.$route.query.item
    this.getAllCompany()
    this.getCompanyOrderList(this.id, this.range)

  }

}

</script>
<style lang="stylus">
@import '~styles/mixins.styl'
.matchingDetail
  background #f7f9fb
  padding 0 20px
  font-size 12px
  overflow-y auto
  min-width 818px
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../assets/images/01/nav_arrow.png') no-repeat top 21px left 60px #F7F9FB
    span
      color #212832
      margin-left 20px
  .orderview_title
    width calc(100% - 46px)
    line-height 46px
    padding-left 46px
    background url('../../assets/images/01/gaoji_huoyuan.png') no-repeat center left 14px #fff
    span
      float right
      margin-right 20px
  .order_box
    height 160px
    overflow hidden
    position relative
    .el-table--enable-row-hover .el-table__body tr:hover>td
      background #fff
  .order_con
    position relative
    .el-table--enable-row-hover .el-table__body tr:hover>td
      background #fff
  .more
    position absolute
    bottom 0
    width 100%
    height 30px
    line-height 30px
    text-align center
    background #fff
    border-bottom 1px solid #eee
    span
      padding 20px
      cursor pointer
      color #858C96
      background url('../../assets/images/01/more_icon.png') no-repeat center right
    .more_up
      background url('../../assets/images/01/more_arrow_up.png') no-repeat center right
  .order_table
    position relative
    th
      background #e7f0f8
      .cell
        size12()
    td
      size12()
      .carInfo
        width 150px
        margin 0 auto 20px
        div
          color #5E656F
          span
            color #858C96
        .tankbody
          div
            display inline
  .el-table td, .el-table th
    vertical-align top
  .carview_title
    width calc(100% - 46px)
    line-height 46px
    border-bottom 1px solid #eee
    padding-left 46px
    margin-top 20px
    background url('../../assets/images/01/gaoji_cheliang.png') no-repeat center left 14px #fff
  .carview_form
    background #fff
    overflow hidden
    padding-left 14px
    height 50px
    .permission_search
      float left
      margin 9px 10px 0 0
    .searchBtn
      searchBtn()
      margin-left 10px
      margin-top 11px
      float left
      margin-right 20px
    .matchBtn
      float right
      margin-top 9px
      margin-right 20px
    .el-form-item
      margin-bottom 6px
      margin-top 6px
      float left
  .carview_table
    max-height 328px
    overflow-y auto
    th
      background #e7f0f8
      .cell
        size12()
    td
      size12()
      .carInfo
        width 150px
        margin 0 auto
      .loadimgBtn
        color #1B88EE
        text-decoration underline
        cursor pointer
      .loaded
        color #FF6F12
      .wait
        color #5E656F
      .empty
        color #1B88EE
      .oprationBtn
        width 78px
        height 28px
        line-height 0
  .count
    text-align right
    font-size 16px
    color #212832
    line-height 30px
    span
      color #5E656F
      font-size 12px
  .container
    margin-top 20px
    padding 5px
    width calc(100% - 10px)
    height 234px
    background #fff
    overflow hidden
    position relative
    .distance
      width 116px
      height 28px
      position absolute
      top 22px
      left 30px
    #container
      height 100%
      .amap-info-content
        width 214px
        height 106px
        div
          margin-top 5px
      .amap-info-sharp
        clear both
        position absolute
        left -15px
        top 28px
        border-right 8px solid #fff
        border-bottom 8px solid transparent
        border-top 8px solid transparent
        background-image none
        width 8px
        height 0px !important
      span
        margin-left 5px
        font-size 11px
      .info-middle img
        float left
        margin-right 6px
      .label
        color #858C96
  .matchingCarTable
    .el-dialog
      width 310px
      border-radius 5px
      overflow hidden
      top 20%
      .el-dialog__header
        height 42px
        padding 0 20px 0
        background #FFFFFF
        text-align center
        border-bottom 1px solid #CFD5DC
        .el-dialog__title
          line-height 42px
          font-size 13px
          color #858C96
          text-align center
        .el-dialog__headerbtn
          top 12px
          right 12px
          .el-dialog__close
            color #ADB4BE
            font-size 20px
      .el-dialog__body
        padding 0
        .matchingCarDetail
          padding 10px 10px
          p
            text-align center
            line-height 40px
          div
            font-size 13px
            padding-left 20px
            .el-input
              width 100px
              display inline-block
          .remarks
            font-size 12px
            color #f66
        .matchingBtn
          width 100%
          div
            width 50%
            height 34px
            display inline-block
            text-align center
            cursor pointer
            line-height 34px
            &:nth-child(1)
              background #F7F9FB
              color #858C96
            &:nth-child(2)
              background #1B88EE
              color #fff
.el-table::before
  height 0px
.el-select-dropdown__item
  font-size 12px
  height 26px
  line-height 26px
.el-select-dropdown__list
  padding 0
.el-popper .popper__arrow, .el-popper .popper__arrow::after
  border-width 0
.el-popper[x-placement^=bottom]
  margin-top 0
</style>
